import { memo as Memo, Fragment } from 'react';

//* Components
import LongText from '../LongText';
import DoubleImage from '../DoubleImage';
import TripleImage from '../TripleImage';
import SingleImage from '../SingleImage';
import VideoContent from '../VideoContent';
import EditorContent from '../EditorContent';
import Text from '@/components/global/Text';

const ContentBuilder = Memo(({ data, title }) => {
	return (
		<>
			{data?.length > 0
				? data.map((item, ind) => {
						switch (item.sys.contentType.sys.id) {
							case 'doubleImage':
								return (
									<DoubleImage
										key={ind}
										data={item.fields}
									/>
								);

							case 'tripleImage':
								return (
									<TripleImage
										key={ind}
										data={item.fields}
									/>
								);

							case 'longText':
								return (
									<LongText
										key={ind}
										title={title}
										data={item.fields}
									/>
								);

							case 'editorContent':
								return (
									<EditorContent
										key={ind}
										data={item.fields}
									/>
								);

							case 'singleImage':
								return (
									<SingleImage
										key={ind}
										data={item.fields}
									/>
								);

							case 'video':
								return (
									<VideoContent
										key={ind}
										data={item.fields}
									/>
								);

							default:
								return (
									<Text
										tag={'h4'}
										key={ind}>
										none
									</Text>
								);
						}
				  })
				: null}
		</>
	);
});

export default ContentBuilder;
